import { of } from 'rxjs'
import { EpicRefined } from 'interfaces/middleware'
import { map, mergeMap } from 'rxjs/operators'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { GET_CRYPTO_REWARDS_ORDERS } from 'components/features/rewards/rewardsPane/constants/endpoints'
import { CryptoRewardsPaneActions } from 'components/features/rewards/rewardsPane/store/actions'
import { GetCryptoRewardsOrdersListRequestAction } from 'components/features/rewards/rewardsPane/store/actions/orders'

export const loadCryptoRewardsOrdersList: EpicRefined<CryptoRewardsPaneActions | AjaxCatchExtraActions> = (
  (action$, _, { get }) => action$.pipe(
    filterRequestOfType(GetCryptoRewardsOrdersListRequestAction.type, 'request'),
    mergeMap((action) => get(GET_CRYPTO_REWARDS_ORDERS).pipe(
      map(({ response }) => {
        return action.success(response.items)
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
    ))
  )
)
